import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import seasonImg from "../../../assets/images/aside-season.png";
import { GAPersonalBannerLinkToPremium } from "../../../ga/personalCenter";

const PersonalCenterLeftRender = ({ handlePurchaseModalVisible }) => {
  const { t } = useTranslation(["personalCenterSiderBar"]);

  return (
    <>
      <div className="nav-bar mb-4 d-flex flex-row flex-md-column">
        <NavLink to="./profile" className="d-block px-md-4 px-3">
          {t("profile")}
        </NavLink>
        <NavLink to="./history" className="d-block px-md-4 px-3">
          {t("history")}
        </NavLink>
        <NavLink to="./setting" className="d-block px-md-4 px-3">
          {t("setting")}
        </NavLink>
        <NavLink to="./promotion" className="d-block px-md-4 px-3">
          {t("promotion")}
        </NavLink>
      </div>
      <div
        className="season d-none d-md-block"
        onClick={() => {
          handlePurchaseModalVisible(true);
          GAPersonalBannerLinkToPremium();
        }}
      >
        <img src={seasonImg} alt="season banner" className="mw-100" />
      </div>
    </>
  );
};

export default PersonalCenterLeftRender;
